import React from 'react'

const LeavesTab = () => {
  return (
    <div>LeavesTab</div>
  )
}

export default LeavesTab